import APC from './views/apc.c';

export default APC;
